/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampCategoryCampDto } from '../../models/camp-category-camp-dto';
import { CampCategoryCampShowResponse } from '../../models/camp-category-camp-show-response';

export interface PostCampCategoryCampCreate$Params {
  category: string;
  camp: string;
      body: CampCategoryCampDto
}

export function postCampCategoryCampCreate(http: HttpClient, rootUrl: string, params: PostCampCategoryCampCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampCategoryCampShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postCampCategoryCampCreate.PATH, 'post');
  if (params) {
    rb.path('category', params.category, {});
    rb.path('camp', params.camp, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampCategoryCampShowResponse>;
    })
  );
}

postCampCategoryCampCreate.PATH = '/v1/category/{category}/camp/{camp}';
